import { apiRequest } from "../../api/apiRequest";
import { SUBSCRIPTION_ENDPOINT } from "../../api/urls";

export const createSubscription = (id, data) => {
    return apiRequest(
        "POST",
        SUBSCRIPTION_ENDPOINT + "post/subscription/?workspace=" + id,
        data,
    );
};

export const upgradeSubscription = (id, data) => {
    return apiRequest(
        "POST",
        SUBSCRIPTION_ENDPOINT + "upgrade/subscription/?workspace=" + id,
        data,
    );
};

export const fetchSubscriptions = (customer_id) => {
    return apiRequest(
        "GET",
        SUBSCRIPTION_ENDPOINT +
            "get/subscriptions/customer/" +
            customer_id +
            "",
    );
};

export const createPortalSession = (customer_id, workspace_id) => {
    return apiRequest(
        "GET",
        SUBSCRIPTION_ENDPOINT +
            "" +
            customer_id +
            "/get/session/?workspace=" +
            workspace_id,
    );
};
